import { Directive, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[openArticleId]',
  standalone: false,
})
export class OpenArticleIdDirective {
  @Input() openArticleId: string
  @Input() category: boolean = false

  @HostListener('click')
  onHelpDocs() {
    if (this.category) {
      window.open('https://advance.cm/help/category/' + this.openArticleId, '_blank')
    } else if (this.openArticleId) {
      window.open('https://advance.cm/help/article/' + this.openArticleId, '_blank')
    } else {
      window.open('https://advance.cm/help/', '_blank')
    }
  }
}
